import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { HomeComponent } from './home/home.component';
import { AddhotelComponent } from './addhotel/addhotel.component';
import { EdithotelComponent } from './edithotel/edithotel.component';
import { ListhotelComponent } from './listhotel/listhotel.component';

import { HttpModule } from '@angular/http';

import { HotelService } from './services/hotel.service';
import { MessageService } from './services/message.service';

import * as $ from 'jquery';

import { ReceipthotelComponent } from './receipthotel/receipthotel.component';
import { ViewbillComponent } from './viewbill/viewbill.component';
import { PaybillComponent } from './paybill/paybill.component';
import { SerchreportComponent } from './serchreport/serchreport.component';
import { LoginComponent } from './login/login.component';
import { AuthguardGuard } from './authguard.guard';
import { OrderComponent } from './order/order.component';
import { OrderlistComponent } from './orderlist/orderlist.component';
import { UnitsComponent } from './units/units.component';
import { PrintbillComponent } from './printbill/printbill.component';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HomeComponent,
    AddhotelComponent,
    EdithotelComponent,
    ListhotelComponent,
    ReceipthotelComponent,
    ViewbillComponent,
    PaybillComponent,
    SerchreportComponent,
    LoginComponent,
    OrderComponent,
    OrderlistComponent,
    UnitsComponent,
    PrintbillComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
    DataTablesModule,
    TabsModule.forRoot()
  ],
  providers: [HotelService,MessageService,AuthguardGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/app.module.ts